import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, shallowRef } from 'vue'
import { Upload as ElUpload, Message as ElMessage } from 'element-ui'
import { IUploadParams, uploadFile } from '@/api/common/common-api'
import { fileSizeFormatter } from '@/utils'
import { ElUploadInternalFileDetail, ElUploadInternalRawFile, ElUploadProgressEvent, FileListItem } from 'element-ui/types/upload'
import { UploadFileRes } from '@/api/common/common-api-type'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  otherParams: {
    type: Object as PropType<IUploadParams>
  },
  beforeUploadFn: {
    type: Function as PropType<(file: ElUploadInternalRawFile) => Boolean>
  },
  accept: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  maxSize: {
    type: Number,
    default: -1 // < 0 不限制大小
  },
  maxLimit: {
    type: Number,
    default: -1 // < 0 不限制个体
  },
  fileList: {
    type: Array as PropType<UploadFileRes[]>,
    default: () => []
  },
},
  emits: ['change-file-list', 'change-has-uploading', 'change-has-fail-upload'],
  setup(__props, { expose, emit: emits }) {

const props = __props


// change-has-uploading: 是否有文件上传中 status 改变时


const elUploadRef = shallowRef<InstanceType<typeof ElUpload>>()
const tipText = computed(() => `*支持${props.accept.join('、')}，单文件不超过${fileSizeFormatter(props.maxSize, 0)}，单次最多上传${props.maxLimit}个文件`
)
const displayFileList = ref<FileListItem[]>(props.fileList.map<FileListItem>(i => ({ name: i.filename, url: i.id, status: 'success' })))
const hasLoading = ref(false) // 是否有文件正在上传
const hasFailUpload = ref(false) // 上传文件中是否有上传失败文件

const setHasLoading = (fileList: ElUploadInternalFileDetail[]) => {
  const tmp = fileList.some(i => i.status === 'uploading' || i.status === 'ready')
  if(tmp !== hasLoading.value) {
    hasLoading.value = tmp
    emits('change-has-uploading', hasLoading.value)
  }
}

const setHasFailUpload = (fileList: ElUploadInternalFileDetail[]) => {
  const tmp = fileList.some(i => i.status === 'fail')
  if(tmp !== hasFailUpload.value) {
    hasFailUpload.value = tmp
    emits('change-has-fail-upload', hasFailUpload.value)
  }
}

const onSuccessHandler: ElUpload['onSuccess'] = (resp: UploadFileRes, file, fileList) => {
  file.url = resp.id
  emits('change-file-list', [...props.fileList, resp])
  setHasLoading(fileList)
  setHasFailUpload(fileList)
}

const onErrorHandler: ElUpload['onError'] = (err, file, fileList) => {
  fileList.push(file)
  setHasLoading(fileList)
  setHasFailUpload(fileList)
}

const onRemoveHandler: ElUpload['onRemove'] = (file, fileList) => {
  const rs = props.fileList.filter(i => i.id !== file.url)
  emits('change-file-list', rs)
  setHasLoading(fileList)
  setHasFailUpload(fileList)
}

const beforeUploadHandler: ElUpload['beforeUpload'] = (file) => {
  if (props.beforeUploadFn && !props.beforeUploadFn(file)) return false
  if (!validateFileType(file)) {
    ElMessage.error(`仅支持${props.accept.join('、')}`)
    return false
  }
  if (props.maxLimit > 0 && file.size > props.maxSize) {
    ElMessage.error(`文件大小不能超过${fileSizeFormatter(props.maxSize, 0)}`)
    return false
  }
  return true
}

function validateFileType (file: ElUploadInternalRawFile | File) {
  if (props.accept.length > 0 && props.accept.every(i => !file.name.toLowerCase().endsWith(`.${i}`))) {
    return false
  }
  return true
}

function handleDrop (e: DragEvent) {
  const files = e.dataTransfer?.files
  if (files && props.accept.length > 0) {
    for (const file of Array.from(files)) {
      if (!validateFileType(file)) {
        ElMessage.error(`仅支持${props.accept.join('、')}格式`)
        return
      }
    }
  }
}


const onExceedHandler: ElUpload['onExceed'] = () => {
  ElMessage.error(`最多上传${props.maxLimit}个文件`)
}

const myHttpRequest: ElUpload['httpRequest'] = (options) => {
  if(!hasLoading.value) {
    hasLoading.value = true
    emits('change-has-uploading', hasLoading.value)
  }
  uploadFile(
    options.file,
    props.otherParams,
    (progress) => {
      const tmp: ElUploadProgressEvent = {
        percent: progress.loaded / progress.total * 100,
        ...progress
      }
      options.onProgress(tmp)
    })
    .then(({ data }) => {
      options.onSuccess(data)
    }).catch(err => {
      options.onError(err)
    })
}

function clearFiles () {
  elUploadRef.value?.clearFiles()
  emits('change-file-list', [])
  setHasLoading([])
  setHasFailUpload([])
}

expose({
  hasLoading,
  hasFailUpload,
  clearFiles
})


return { __sfc: true,props, emits, elUploadRef, tipText, displayFileList, hasLoading, hasFailUpload, setHasLoading, setHasFailUpload, onSuccessHandler, onErrorHandler, onRemoveHandler, beforeUploadHandler, validateFileType, handleDrop, onExceedHandler, myHttpRequest, clearFiles, ElUpload }
}

})